import { css } from "@linaria/core";
import { colors } from "@ui/Theme";

export const blockHeader = css`
  margin-bottom: 16px;
`;

export const blockHeaderTitle = css`
  word-break: break-word;
  min-height: 30px;
`;

export const blockHeaderSubtitle = css`
  color: ${colors.titanium700};
`;

export const blockHeaderActions = css`
  margin-left: auto;
`;
